import { render, staticRenderFns } from "./GlossSelectionBar.vue?vue&type=template&id=706ed546"
import script from "./GlossSelectionBar.vue?vue&type=script&lang=js"
export * from "./GlossSelectionBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports